/* Mile High Airguns — cart drawer, AJAX add-to-cart, predictive search */
(function () {
  var money = function (c) { return '$' + (c / 100).toFixed(2); };
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------------- Cart drawer ---------------- */
  var overlay  = document.getElementById('CartOverlay');
  var itemsEl  = document.getElementById('CartItems');
  var subtotal = document.getElementById('CartSubtotal');
  var footEl   = document.getElementById('CartFoot');
  var emptyEl  = document.getElementById('CartEmpty');
  var progEl   = document.getElementById('CartProgress');
  var countEls = document.querySelectorAll('[data-cart-count]');

  function openDrawer()  { document.body.classList.add('cart-open'); }
  function closeDrawer() { document.body.classList.remove('cart-open'); }

  function renderProgress(cart) {
    if (!progEl) return;
    var thr = parseInt(progEl.getAttribute('data-threshold'), 10) || 0;
    if (thr <= 0 || cart.item_count === 0) { progEl.hidden = true; return; }
    var msg = progEl.querySelector('.cart-progress__msg');
    var fill = progEl.querySelector('.cart-progress__fill');
    var pct = Math.max(0, Math.min(100, (cart.total_price / thr) * 100));
    fill.style.width = pct + '%';
    var remain = thr - cart.total_price;
    if (remain > 0) {
      progEl.classList.remove('is-complete');
      msg.innerHTML = 'You\u2019re <strong>' + money(remain) + '</strong> away from free shipping';
    } else {
      progEl.classList.add('is-complete');
      msg.innerHTML = '\u2713 Free shipping unlocked';
    }
    progEl.hidden = false;
  }

  function render(cart) {
    countEls.forEach(function (e) { e.textContent = cart.item_count; e.hidden = cart.item_count === 0; });
    renderProgress(cart);
    if (!itemsEl) return;
    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footEl) footEl.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (it) {
      var media = it.image
        ? '<img class="cd-item__img" src="' + it.image + '" alt="">'
        : '<div class="cd-item__ph"></div>';
      return '<div class="cd-item" data-key="' + esc(it.key) + '">' + media +
        '<div class="cd-item__mid">' +
          '<div class="cd-item__vendor">' + esc(it.vendor || '') + '</div>' +
          '<div class="cd-item__title">' + esc(it.product_title) + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cd-item__variant">' + esc(it.variant_title) + '</div>' : '') +
          '<div class="cd-item__row">' +
            '<div class="cd-qty">' +
              '<button type="button" data-dec aria-label="Decrease">&minus;</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-inc aria-label="Increase">+</button>' +
            '</div>' +
            '<div class="cd-item__price">' + money(it.final_line_price) + '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cd-item__rm" data-remove aria-label="Remove">&times;</button>' +
      '</div>';
    }).join('');
    if (subtotal) subtotal.textContent = money(cart.total_price);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(render);
  }
  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }
  function addVariant(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || 'Unable to add this option. Please try again.'); return data; }); })
      .then(function () { return getCart().then(openDrawer).catch(function () { window.location.assign('/cart'); }); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.js-add');
    if (!form) return;
    e.preventDefault();
    var idEl = form.querySelector('[name=id]');
    if (!idEl) { form.submit(); return; }
    var qtyEl = form.querySelector('[name=quantity]');
    var btn = form.querySelector('[type=submit]');
    if (form.getAttribute('data-submitting') === 'true' || (btn && btn.disabled)) return;
    form.setAttribute('data-submitting', 'true');
    var errorEl = form.querySelector('[data-cart-error]');
    if (!errorEl) { errorEl = document.createElement('p'); errorEl.setAttribute('data-cart-error', ''); errorEl.setAttribute('role', 'alert'); form.appendChild(errorEl); }
    errorEl.hidden = true;
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    addVariant(idEl.value, qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1)
      .catch(function (error) { errorEl.textContent = error.message || 'Unable to add this option. Please try again.'; errorEl.hidden = false; })
      .finally(function () { form.removeAttribute('data-submitting'); if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } form.dispatchEvent(new CustomEvent('mha:cart-settled', { bubbles: true })); });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); getCart().then(openDrawer); return; }
    if (e.target.closest('[data-cart-close]') || e.target === overlay) { closeDrawer(); return; }
    if (e.target.closest('[data-sticky-add]')) {
      var f = document.querySelector('.product-form');
      if (f) { if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
      return;
    }
    var row = e.target.closest('.cd-item');
    if (!row) return;
    var key = row.getAttribute('data-key');
    var span = row.querySelector('.cd-qty span');
    var q = parseInt(span ? span.textContent : '1', 10);
    if (e.target.closest('[data-inc]')) change(key, q + 1);
    else if (e.target.closest('[data-dec]')) change(key, Math.max(0, q - 1));
    else if (e.target.closest('[data-remove]')) change(key, 0);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  if (document.querySelector('[data-cart-count]')) getCart();

  /* ---------------- Predictive search ---------------- */
  var searchWrap = document.querySelector('[data-search]');
  if (searchWrap) {
    var input = searchWrap.querySelector('[data-search-input]');
    var panel = searchWrap.querySelector('[data-predictive]');
    var timer;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { panel.hidden = true; panel.innerHTML = ''; return; }
      timer = setTimeout(function () { run(q); }, 220);
    });

    function run(q) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6' +
        '&resources[options][unavailable_products]=' + (searchWrap.getAttribute('data-unavailable') || 'last');
      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) { draw(q, data); })
        .catch(function () { panel.hidden = true; });
    }

    function draw(q, data) {
      var res = (data.resources && data.resources.results) || {};
      var products = res.products || [];
      var colls = res.collections || [];
      if (!products.length && !colls.length) {
        panel.innerHTML = '<div class="predictive__empty">No matches for \u201c' + esc(q) + '\u201d</div>';
        panel.hidden = false; return;
      }
      var html = '';
      if (colls.length) {
        html += '<div class="predictive__label mono">Categories</div>';
        html += colls.map(function (c) {
          return '<a class="predictive__coll" href="' + c.url + '">' + esc(c.title) + '</a>';
        }).join('');
      }
      if (products.length) {
        html += '<div class="predictive__label mono">Products</div>';
        html += products.map(function (p) {
          var src = p.image || (p.featured_image && p.featured_image.url) || '';
          var img = src ? '<img src="' + src + '" alt="">' : '<span class="predictive__ph"></span>';
          var price = (typeof p.price === 'string') ? '<span class="predictive__price">' + p.price + '</span>' : '';
          return '<a class="predictive__item" href="' + p.url + '">' + img +
            '<span class="predictive__meta"><span class="predictive__title">' + esc(p.title) + '</span>' +
            '<span class="predictive__vendor">' + esc(p.vendor || '') + '</span></span>' + price + '</a>';
        }).join('');
      }
      html += '<a class="predictive__all" href="/search?q=' + encodeURIComponent(q) + (searchWrap.getAttribute('data-unavailable') === 'hide' ? '&options%5Bunavailable_products%5D=hide' : '') + '">See all results \u2192</a>';
      panel.innerHTML = html;
      panel.hidden = false;
    }

    document.addEventListener('click', function (e) { if (!searchWrap.contains(e.target)) panel.hidden = true; });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') panel.hidden = true; });
  }
})();

/* Category carousel: shows a few tiles, auto-rotates through the full list */
(function () {
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-carousel-track]');
    if (!track || track.children.length === 0) return;
    var tiles = track.children;
    var prev = car.querySelector('[data-carousel-prev]');
    var next = car.querySelector('[data-carousel-next]');
    var index = 0, timer = null;

    function metrics() {
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      var tileW = tiles[0].getBoundingClientRect().width + gap;
      var vp = track.parentElement.getBoundingClientRect().width;
      var perView = Math.max(1, Math.round(vp / tileW));
      return { tileW: tileW, maxIndex: Math.max(0, tiles.length - perView) };
    }
    function go(i) {
      var m = metrics();
      if (m.maxIndex === 0) {
        track.style.transform = 'translateX(0)';
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }
      if (prev) prev.hidden = false;
      if (next) next.hidden = false;
      if (i > m.maxIndex) i = 0;
      if (i < 0) i = m.maxIndex;
      index = i;
      track.style.transform = 'translateX(' + (-index * m.tileW) + 'px)';
    }
    function start() { stop(); timer = setInterval(function () { go(index + 1); }, 3500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });
    car.addEventListener('mouseenter', stop);
    car.addEventListener('mouseleave', start);
    car.addEventListener('focusin', stop);
    car.addEventListener('focusout', start);
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { go(index); }, 150); });

    go(0);
    start();
  });
})();

/* Infinite scroll on collection pages (auto-load next page, Load more fallback) */
(function () {
  var foot = document.querySelector('[data-infinite-scroll]');
  if (!foot) return;
  var grid = document.querySelector('[data-infinite-grid]');
  var sentinel = foot.querySelector('[data-infinite-sentinel]');
  var spinner = foot.querySelector('[data-infinite-spinner]');
  var link = foot.querySelector('[data-infinite-next]');
  if (!grid || !link) return;

  var nextUrl = link.getAttribute('href');
  var loading = false;
  var observer = null;

  function finish() {
    if (link) link.remove();
    if (sentinel) sentinel.remove();
    if (spinner) spinner.hidden = true;
    if (observer) observer.disconnect();
  }

  function load() {
    if (loading || !nextUrl) return;
    loading = true;
    if (spinner) spinner.hidden = false;
    if (link) link.style.display = 'none';

    fetch(nextUrl, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.querySelector('[data-infinite-grid]');
        if (ng) {
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(ng.children).forEach(function (n) { frag.appendChild(n); });
          grid.appendChild(frag);
        }
        var nl = doc.querySelector('[data-infinite-next]');
        nextUrl = nl ? nl.getAttribute('href') : null;
        loading = false;
        if (spinner) spinner.hidden = true;
        if (!nextUrl) {
          finish();
        } else if (link) {
          link.style.display = '';
          link.setAttribute('href', nextUrl);
        }
        /* a page of hidden (sold-out) products adds no height, so the observer never re-fires */
        if (nextUrl && sentinel && sentinel.getBoundingClientRect().top < window.innerHeight + 700) load();
      })
      .catch(function () {
        loading = false;
        if (spinner) spinner.hidden = true;
        if (link) link.style.display = '';
      });
  }

  link.addEventListener('click', function (e) { e.preventDefault(); load(); });

  if ('IntersectionObserver' in window && sentinel) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) load(); });
    }, { rootMargin: '700px 0px' });
    observer.observe(sentinel);
  }
})();

/* Product image gallery + zoom lightbox */
(function () {
  var gallery = document.querySelector('[data-gallery]');
  var lightbox = document.querySelector('[data-lightbox]');
  if (!gallery || !lightbox) return;

  var mainImg = gallery.querySelector('[data-main-img]');
  var thumbs = gallery.querySelectorAll('[data-thumb]');
  var dataEl = gallery.querySelector('[data-gallery-data]');
  var images = [];
  try { images = JSON.parse(dataEl.textContent) || []; } catch (e) { images = []; }
  if (images.length === 0) return;

  var lbImg = lightbox.querySelector('[data-lightbox-img]');
  var lbStage = lightbox.querySelector('[data-lightbox-stage]');
  var lbCount = lightbox.querySelector('[data-lightbox-count]');
  var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
  var nextBtn = lightbox.querySelector('[data-lightbox-next]');
  var current = 0;
  var zoomed = false;

  // In-page thumbnail switching
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      var i = parseInt(t.getAttribute('data-index'), 10) || 0;
      current = i;
      if (mainImg) mainImg.src = t.getAttribute('data-full');
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      t.classList.add('is-active');
    });
  });

  function resetZoom() {
    zoomed = false;
    lbImg.classList.remove('is-zoomed');
    lbImg.style.transform = '';
    lbImg.style.transformOrigin = 'center center';
  }
  function show(i) {
    current = (i + images.length) % images.length;
    resetZoom();
    lbImg.src = images[current];
    if (lbCount) lbCount.textContent = (current + 1) + ' / ' + images.length;
    var multi = images.length > 1;
    if (prevBtn) prevBtn.hidden = !multi;
    if (nextBtn) nextBtn.hidden = !multi;
  }
  function open(i) {
    show(i);
    lightbox.hidden = false;
    document.body.classList.add('lightbox-open');
  }
  function close() {
    lightbox.hidden = true;
    document.body.classList.remove('lightbox-open');
    resetZoom();
  }

  var openBtn = gallery.querySelector('[data-gallery-open]');
  if (openBtn) openBtn.addEventListener('click', function () { open(current); });

  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
  lightbox.querySelector('[data-lightbox-close]').addEventListener('click', close);

  // Click backdrop (not image) closes
  lbStage.addEventListener('click', function (e) { if (e.target === lbStage) close(); });

  // Click image toggles 2x zoom; pan follows cursor
  lbImg.addEventListener('click', function (e) {
    e.stopPropagation();
    zoomed = !zoomed;
    lbImg.classList.toggle('is-zoomed', zoomed);
    lbImg.style.transform = zoomed ? 'scale(2.3)' : '';
  });
  lbStage.addEventListener('mousemove', function (e) {
    if (!zoomed) return;
    var r = lbImg.getBoundingClientRect();
    var x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
    var y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
    lbImg.style.transformOrigin = x + '% ' + y + '%';
  });

  document.addEventListener('keydown', function (e) {
    if (lightbox.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(current - 1);
    else if (e.key === 'ArrowRight') show(current + 1);
  });
})();
